/** #1229: the customer comes back from the Chargebee hosted page to `?trialCard=return`. */
export const TRIAL_CARD_RETURN_PARAM = 'trialCard';
export const TRIAL_CARD_RETURN_VALUE = 'return';

export function isTrialCardReturn(search: string): boolean {
  return new URLSearchParams(search).get(TRIAL_CARD_RETURN_PARAM) === TRIAL_CARD_RETURN_VALUE;
}

/** The URL without the return marker, so a refresh or a shared link never re-fires the call. */
export function withoutTrialCardReturn(search: string, pathname: string, hash: string): string {
  const params = new URLSearchParams(search);
  params.delete(TRIAL_CARD_RETURN_PARAM);
  const rest = params.toString();
  return `${pathname}${rest.length > 0 ? `?${rest}` : ''}${hash}`;
}
